import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import VoiceCloningLanding from "./VoiceCloningLanding";
import VoiceCloning from "./voiceCloningProcess/VoiceCloning";
import VoiceCloningContainer from "./VoiceCloningContainer";

function VoiceCloningRouter() {
    return (
        <Routes>
            <Route path="/" element={<VoiceCloningContainer />} />
            <Route path="create/*" element={<VoiceCloning />} />
            <Route path="chat/:modelId" element={<VoiceCloningContainer />} />
            <Route path="landing" element={<VoiceCloningLanding />} />
            <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
    );
}

export default VoiceCloningRouter;
